import { PropsWithChildren } from 'react';

import { cn } from '@/utils/cn';

type Props = PropsWithChildren & {
    className?: string;
    header: string;
    title: string;
};

export const SectionDescriptionHorizontal = ({
    children,
    className,
    header,
    title,
}: Props) => (
    <div
        className={cn(
            `
              flex flex-col items-center gap-10

              lg:flex-row
            `,
            className,
        )}
    >
        <div className="flex w-full flex-1 flex-col gap-10">
            <h3 className="typography-sub-heading pb-0 uppercase">{title}</h3>

            <h2
                className={`
                  text-[40px] font-bold leading-[100%] -tracking-wider

                  sm:text-[88px]
                `}
            >
                {header}
            </h2>
        </div>

        <div
            className={`
              flex flex-1 flex-col gap-6 text-pretty

              [&_p]:typography-body1
            `}
        >
            {children}
        </div>
    </div>
);
